import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { EMAIL_QUERY_PARAM } from '@app-shared/constants/constants';
import { decodeInfoMailAccount } from '@app-utils/search-params';
import { EmailsContentComponent } from '@app-components/emails-content/emails-content.component';
import { Subscription } from 'rxjs';
import { UserWorkspaceService } from '@app-services/user-workspace-service';

@Component({
  selector: 'app-emails-container',
  templateUrl: './emails-container.component.html',
  styleUrls: ['./emails-container.component.scss'],
  imports: [TranslateModule, EmailsContentComponent],
})
export class EmailsContainerComponent implements OnInit, OnDestroy {
  public isAnyFolders = true;
  router$: Subscription;

  constructor(
    private router: Router,
    public userWorkspaceService: UserWorkspaceService
  ) {}

  ngOnInit(): void {
    if (!this.userWorkspaceService.mailAccounts.length) return;
    this.setInfoOpenMAilAccount(window.location.href);

    this.router$ = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setInfoOpenMAilAccount(window.location.href);
      });
  }

  setInfoOpenMAilAccount(url: string): void {
    const newUrl = new URL(url);
    const search: string = newUrl.searchParams.get(EMAIL_QUERY_PARAM) ?? '';
    const data = decodeInfoMailAccount(search);
    this.isAnyFolders = !!data?.folder;
  }

  ngOnDestroy(): void {
    this.router$?.unsubscribe();
  }
}
